const state = {
    isInfoRequestVisible: false,
    message: null
};

const getters = {
    isInfoRequestVisible: state => state.isInfoRequestVisible,
    message: state => state.message
};

const mutations = {
    setInfoRequestVisible: (state, data) => state.isInfoRequestVisible = data,
    setMessage: (state, data) => state.message = data
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
};